import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CouponTypes } from '@frontend/sports/coupons/feature/models';
import { GridEvent, GridMedia, Group } from '@frontend/sports/grid/core/feature/model';
import { TrackingSource } from '@frontend/sports/tracking/feature';

import { EventLinkConfig } from '../../navigation-core/url-helper.service';
import { CorrectScoreOptionGroupComponent } from './correct-score/correct-score-option-group.component';
import { GoalScorerOptionGroupComponent } from './goal-scorer/goal-scorer-option-group.component';

@Component({
    selector: 'ms-coupon-event',
    templateUrl: 'coupon-event.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CorrectScoreOptionGroupComponent, CommonModule, GoalScorerOptionGroupComponent],
})
export class CouponEventComponent {
    @Input() couponEvent: GridEvent;
    @Input() couponGroups: Group[];
    @Input() tracking: TrackingSource;
    @Input() linkConfig: EventLinkConfig;
    @Input() media: GridMedia;
    @Input() favouriteToggle: boolean;
    @Input() promotedFixtureIds: { [fixtureId: number]: number } = {};
    @Input() showParticipantImage: boolean;
    @Input() betDetails = '';
    @Input() couponType: CouponTypes;
    @Input() periodGroup?: number;

    @Output() moreBetsClicked = new EventEmitter<void>();
    @Output() statsClicked = new EventEmitter<void>();

    couponTypes = CouponTypes;
}
